













import { Component, Vue, Prop, namespace } from 'nuxt-property-decorator'
import { mdiPoll } from '@mdi/js'
import { NotificationOptions } from 'vue-notification'
import ComponentFormButtonIcon from '~/components/form/button-icon.vue'
import { ICompareItem } from '~/assets/interfaces/compare'
import { COMPARE_PATH } from '~/assets/config/path'
import { filterUrl } from '~/assets/filters/url'
const compareStore = namespace('compare')
const siteStore = namespace('site')
@Component({
  components: {
    ComponentFormButtonIcon,
  },
})
export default class ComponentAddToCompareIconButton extends Vue {
  @Prop({ type: [String, Number] }) private productId: string | number
  @Prop({ type: [String, Number], default: 22 }) private size!: string | number
  @compareStore.Action('toCompare') private toCompare!: (args: {
    id: number | string
  }) => Promise<void>

  @compareStore.State('items') private compareItems!: ICompareItem[]
  @siteStore.Getter('getOptionsCompare') private isCompareEnabled!: boolean

  private mdiPoll = mdiPoll
  private isLoading: boolean = false
  private async addToCompare() {
    if (!this.isLoading) {
      this.isLoading = true
      const wasInCompare = this.inCompare
      try {
        await this.toCompare({ id: this.productId })
        if (!wasInCompare) {
          Vue.notify({
            group: 'default',
            type: 'compare',
            title: 'Товар добавлен в сравнение',
            text: `<a href="${filterUrl(COMPARE_PATH)}">Перейти</a>`,
            duration: 5000,
          } as NotificationOptions)
        }
      } finally {
        this.isLoading = false
      }
    }
  }

  private get inCompare(): boolean {
    return !!this.compareItems.find((item) => item.id === this.productId)
  }
}
